import React from 'react';

const JS_History = () => {
  return (
    <div >
      <h1>JS_History</h1>
      <p>Placeholder component for: "JS History"</p>
    </div>
  );
};

export default JS_History;
